import * as React from "react";
import { MFilter } from "@/components/ui/atoms/MFilter";
import { IconFilter, IconX } from "@tabler/icons-react";

const MFilterTest = () => {
  const [selected, setSelected] = React.useState<"default" | "selected">("default");

  return (
    <div className="p-8 space-y-8 bg-[#F6F6F6] min-h-screen">
      <h2 className="text-xl font-semibold mb-4">MFilter Atom Demo</h2>
      <div className="flex flex-row gap-4 mb-8">
        <MFilter text="Default Filter" selected={false} onClick={() => setSelected("selected")} />
        <MFilter text="Selected Filter" selected={true} onClick={() => setSelected("default")} />
        <MFilter
          text="Custom Icon"
          selected={selected === "selected"}
          rightIcon={<IconFilter size={16} />}
          onClick={() => setSelected(selected === "selected" ? "default" : "selected")}
        />
        <MFilter text="Dismiss" selected={false} rightIcon={<IconX size={16} />} />
      </div>
      <div className="text-gray-500 text-sm">Try clicking the filters to toggle states. The right icon can also be customized.</div>
    </div>
  );
};

export default MFilterTest;
